import React from "react";

const ComparativaPlanes = () => {
  const rows = [
    { label: "Reserva de turnos por WhatsApp", bot: true, mashia: true },
    { label: "Confirmación automática de asistencia", bot: true, mashia: true },
    { label: "Recordatorio el día del turno (día anterior y mismo día)", bot: true, mashia: true },
    { label: "Consulta de turnos del paciente", bot: true, mashia: true },
    { label: "Cancelación de turnos (según reglas configuradas)", bot: true, mashia: true },
    { label: "Validación de cancelaciones con 24h de anticipación", bot: true, mashia: true },
    { label: "Registro del nombre del paciente", bot: true, mashia: true },
    { label: "Fraccionamiento flexible (30 min, 1 h, 1 h 30 min)", bot: true, mashia: true },
    { label: "Configuración de días y horarios por doctor", bot: "Carga manual", mashia: "Gestionado por nuestro equipo" },
    { label: "Vista de turnos del día actual", bot: true, mashia: true },
    { label: "Vista anticipada de turnos del día siguiente", bot: true, mashia: true },
    { label: "Modo consulta para personal sin permisos de edición", bot: true, mashia: true },
    { label: "Edición y actualización de agenda", bot: "Manual", mashia: "Nosotros lo actualizamos" },
    { label: "Interfaz adaptable a distintos rubros (salud, estética, etc)", bot: true, mashia: true },
    { label: "Gestión completa de agenda por nuestro equipo", bot: false, mashia: true },
    { label: "Soporte técnico y funcional con prioridad", bot: false, mashia: true },
    { label: "Ideal para...", bot: "Centros con recepción", mashia: "Profesionales sin secretaría" },
  ];

  const renderCell = (value) => {
    if (value === true) return "✅";
    if (value === false) return "–";
    return value;
  };

  return (
    <div
      id="comparativa"
      style={{
        backgroundColor: "#fff3e0",
        padding: "60px 20px"
      }}
    >
      <div
        style={{
          maxWidth: "1300px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "30px",
            color: "#f57c00"
          }}
        >
          Todo lo que incluye Imagy
        </h2>

        {/* Tabla con scroll horizontal */}
        <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
            <thead>
              <tr>
                <th style={thStyle}>Funcionalidad</th>
                <th style={thStyle}>Incluido</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={tdLabelStyle}>{row.label}</td>
                  <td style={tdValueStyle}>{renderCell(row.bot)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Estilos responsivos */}
      <style>
        {`
          @media (max-width: 768px) {
            table {
              font-size: 14px !important;
            }
            td, th {
              padding: 8px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

const thStyle = {
  backgroundColor: "#FFE0B2",
  color: "#333",
  padding: "12px",
  fontWeight: "bold",
  textAlign: "left",
  fontSize: "16px"
};

const tdLabelStyle = {
  padding: "10px 12px",
  color: "#333",
  fontSize: "15px",
  fontWeight: "500",
  verticalAlign: "top"
};

const tdValueStyle = {
  padding: "10px 12px",
  textAlign: "center",
  fontSize: "18px",
  fontWeight: "bold",
  color: "#222"
};

export default ComparativaPlanes;
